import { render, staticRenderFns } from "./join.vue?vue&type=template&id=5c6a0fca&scoped=true&"
import script from "./join.vue?vue&type=script&lang=js&"
export * from "./join.vue?vue&type=script&lang=js&"
import style0 from "./join.vue?vue&type=style&index=0&id=5c6a0fca&lang=scss&scoped=true&"
import style1 from "./join.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6a0fca",
  null
  
)

export default component.exports